import { useEffect } from "react";
import { useAdViewAd } from "src/context/AdViewProviderContext.tsx";
import type { SafetyTabs } from "src/types/safetyElements.ts";
import usePulse from "src/utils/pulse-tracking/usePulse.ts";
import { ATractor } from "../views/A-tractor.tsx";
import { Agriculture } from "../views/Agriculture.tsx";
import { Boat } from "../views/Boat.tsx";
import { Bus } from "../views/Bus.tsx";
import { Caravan } from "../views/Caravan.tsx";
import { CarLeasing } from "../views/CarLeasing.tsx";
import { CarLeasingBusiness } from "../views/CarLeasingBusiness.tsx";
import { CarNew } from "../views/CarNew.tsx";
import { CarUsed } from "../views/CarUsed.tsx";
import { CarUsedBusiness } from "../views/CarUsedBusiness.tsx";
import { Construction } from "../views/Construction.tsx";
import { MobileHome } from "../views/MobileHome.tsx";
import { Motorbike } from "../views/Motorbike.tsx";
import { Truck } from "../views/Truck.tsx";

export type AdProps = {
  safetyElements: SafetyTabs[];
};

const Ad = (props: AdProps) => {
  const { trackPageView, trackEventCollectorPageView } = usePulse();
  const ad = useAdViewAd();

  useEffect(() => {
    trackPageView();
    trackEventCollectorPageView();
  }, [trackEventCollectorPageView, trackPageView]);

  const adViewType = ad?.adViewType;

  switch (adViewType) {
    case "car-new":
      return <CarNew ad={ad} {...props} />;
    case "car-used":
      return <CarUsed ad={ad} {...props} />;
    case "car-leasing":
      return <CarLeasing ad={ad} {...props} />;
    case "car-leasing-business":
      return <CarLeasingBusiness ad={ad} {...props} />;
    case "car-used-business":
      return <CarUsedBusiness ad={ad} {...props} />;
    case "boat-dock":
    case "boat-motor":
    case "boat-new-sale":
    case "boat-rent":
    case "boat-sale":
    case "boat-wanted":
      return <Boat ad={ad} {...props} />;
    case "motorcycle":
    case "atv":
    case "moped":
    case "snowmobile":
      return <Motorbike ad={ad} {...props} />;
    case "agriculture-thresher":
    case "agriculture-tractor":
    case "agriculture-tools":
      return <Agriculture ad={ad} {...props} />;
    case "mobile-home":
      return <MobileHome ad={ad} {...props} />;
    case "caravan":
      return <Caravan ad={ad} {...props} />;
    case "truck":
      return <Truck ad={ad} {...props} />;
    case "construction":
      return <Construction ad={ad} {...props} />;
    case "bus":
      return <Bus ad={ad} {...props} />;
    case "a-tractor":
      return <ATractor ad={ad} {...props} />;
    default:
      throw new Error(`adview-type not implemented: ${adViewType}`);
  }
};

export default Ad;
